import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { Accordion, AccordionItem } from "react-light-accordion";
import Plan_bg from "../images/Plan_Bg.webp";
import { Link } from "react-router-dom";
import axios from "axios";

const faqs = [
  {
    q: "What broadband plans does Netplus offer?",
    a: "Netplus offers a range of broadband plans with different speeds and benefits to suit home internet needs. The current broadband plans page lists options from 75 Mbps up to 1 Gbps, with plan prices and benefits shown on the page.",
  },
  {
    q: "What is the cheapest Netplus broadband plan?",
    a: "The current Netplus broadband plans page lists the NetZ 75 Mbps plan starting at ₹449 per month. Plan availability, pricing, and benefits may vary, so customers should check the current plans page for the latest details.",
  },
  {
    q: "What is the fastest Netplus broadband plan?",
    a: "The current Netplus broadband plans page lists speeds up to 1 Gbps (1000 Mbps). The availability and benefits of the 1 Gbps plan depend on the customer's location and applicable plan terms.",
  },
  {
    q: "What Netplus broadband plan is best for my home?",
    a: "The right Netplus broadband plan depends on the number of connected devices and how the connection is used. For basic browsing and everyday use, lower-speed plans may be sufficient, while streaming, gaming, video calls, work from home, and multiple connected devices may require higher speeds.",
  },
  {
    q: "Does Netplus broadband offer unlimited data?",
    a: "Yes. The broadband plans currently displayed on the Netplus website include unlimited data. Customers should check the individual plan details for the latest terms and benefits.",
  },
  {
    q: "What broadband speeds are available with Netplus?",
    a: "The current Netplus broadband plans page lists speeds including 75 Mbps, 100 Mbps, 150 Mbps, 200 Mbps, 250 Mbps, 300 Mbps, 500 Mbps, 600 Mbps, and 1000 Mbps. The plans and availability may vary by location.",
  },
  {
    q: "How can I get a new Netplus broadband connection?",
    a: "To get a new Netplus broadband connection, choose a suitable broadband plan and use the Book Now option to submit your details. Netplus can then contact you regarding availability and installation. You can also visit www.netplus.co.in or call 70875-70875.",
  },
  {
    q: "Is Netplus broadband available in my area?",
    a: "Netplus broadband availability depends on your location. Netplus services are available across North India, including Punjab, Chandigarh, Haryana, Himachal Pradesh, Jammu & Kashmir and Rajasthan. Use the Book Now option or call 70875-70875 to confirm availability at your address.",
  },
  {
    q: "How long does it take to get a new Netplus broadband connection?",
    a: "Netplus states that a new broadband connection generally takes around 5 working hours to become active, subject to service availability, installation requirements, and other applicable conditions.",
  },
  {
    q: "Can I change my existing Netplus broadband plan?",
    a: "Yes. Existing Netplus broadband customers can request a change to their broadband plan. Customers can contact Netplus customer support on 70875-70875 for assistance with changing their plan and to confirm the available options.",
  },
];

export const BroadbandFaqs = () => (
  <>
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        })}
      </script>
    </Helmet>
    <section id="faq">
      <div className="faq">
        <div
          className="container"
          style={{
            background: "#fff",
            backgroundImage: "none",
            marginTop: -100,
          }}
        >
          <div className="row">
            <div className="web-container">
              <div
                className="heading"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <h4>Broadband Plans – Frequently Asked Questions</h4>
              </div>

              <div
                className="faqcont"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <Accordion atomic={true}>
                  {faqs.map((f, i) => (
                    <AccordionItem key={i} title={`${i + 1}. ${f.q}`}>
                      <div className="accordiancont">
                        <p>{f.a}</p>
                      </div>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export const Broadband = ({ slugData }) => {
  const slug = slugData ? slugData : "";

  var decodeHTML = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function createMarkup(content) {
    return { __html: decodeHTML(content) };
  }

  var settings3 = {
    dots: false,
    navigation: true,
    loop: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    speed: 300,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1340, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 800, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  const [pagedata, setPagedata] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(
        window.weburl + `api/plans.php?catID=3&pid=${slug}`,
      );
      if (mounted) {
        setPagedata(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      {pagedata.data ? (
        <div
          className="planslider"
          data-aos="fade-up"
          data-aos-offset="200"
          data-aos-duration="600"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          <Slider {...settings3}>
            {pagedata.data.map((getData) => {
              const newValues = getData.features.split("|_");
              return (
                <div key={getData.plan_id}>
                  <div className="plansitem">
                    <div className="ptag">
                      <h5
                        dangerouslySetInnerHTML={createMarkup(getData.pname)}
                      ></h5>
                    </div>
                    <div className="image_plans_div">
                      <div className="image_plan">
                        <img src={Plan_bg} alt="Plan Image" />
                      </div>
                      <p
                        dangerouslySetInnerHTML={createMarkup(getData.ptitle)}
                      ></p>
                    </div>
                    <div className="price">
                      <div className="sprice">
                        <h6>{getData.price}</h6>
                      </div>
                      {getData.features ? (
                        <ul>
                          {newValues.map((featuresValue, idx) => {
                            return featuresValue ? (
                              <li
                                key={idx}
                                dangerouslySetInnerHTML={createMarkup(
                                  featuresValue,
                                )}
                              ></li>
                            ) : null;
                          })}
                        </ul>
                      ) : null}
                      <div className="buttnprop">
                        <Link to={"/book-now/" + getData.plan_id}>
                          <span>Book Now</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      ) : null}
    </>
  );
};
